import clsx from "clsx";

export const Button = ({
  type = "primary",
  children,
  size = "md",
  className,
  onClick,
}) => {
  const typeClasses =
    type === "primary"
      ? "bg-[#ee6c4d] text-white bg-red-700  hover:opacity-90"
      : type === "secondary"
      ? "bg-primary-marine-blue text-white hover:opacity-70"
      : "bg-neutral-alabaster";
  const sizeClasses =
    size === "sm"
      ? "text-sm p-0"
      : size === "lg"
      ? "text-lg px-5 py-2 font-medium"
      : "px-5 py-2 font-medium";
  return (
    <button
      onClick={onClick}
      className={clsx(`rounded `, typeClasses, sizeClasses, className)}
    >
      {children}
    </button>
  );
};
